/**
 * Archivo generado automáticamente durante el build.
 * No editar manualmente.
 */
export const VERSION_INFO = {
  version: '1.0.0',
  commitHash: 'ee5d127'
};
